import { Checkbox, Table } from '@mairistem/composants';
import {
	type Gabarit,
	NATURES_DOCUMENTS,
	TYPE_GABARIT,
} from '@mairistem/finances-utils';
import { isNewIdentifiant, newIdentifiant } from '@mairistem/tools';
import { isNil } from 'lodash';
import React from 'react';
import type NatureCondition from '@/src/interfaces/natureCondition';
import {
	getLibelleTypeGabarit,
	getNatureFromGabarits,
} from '@/src/utils/piecesJointes';

interface EtapeJustificatifProps {
	onChange: any;
	naturesConditions: NatureCondition[];
	deletedNaturesConditions: number[];
	gabaritsPj: Gabarit[];
}
const gabaritSubvention: string[] = [
	TYPE_GABARIT.PROJET,
	TYPE_GABARIT.SUBVENTION_PERCUE,
];
const EtapeJustificatif = ({
	naturesConditions = null,
	deletedNaturesConditions = null,
	onChange = null,
	gabaritsPj = null,
}: EtapeJustificatifProps) => {
	const naturesGabarit = getNatureFromGabarits(gabaritsPj);

	const handleChangeNatureCondition = (
		gabarit: any,
		natureCondition: NatureCondition,
		checked,
	) => {
		if (checked) {
			onChange?.({
				naturesConditions: [
					...(naturesConditions ?? []),
					{
						identifiant: newIdentifiant(),
						codeNature: gabarit.identifiant,
					},
				],
			});
		} else {
			onChange?.({
				naturesConditions: [
					...naturesConditions.filter(
						(n) => n.identifiant !== natureCondition?.identifiant,
					),
				],
				deletedNaturesConditions: [
					...deletedNaturesConditions,
					...(!isNewIdentifiant(natureCondition?.identifiant)
						? [natureCondition?.identifiant]
						: []),
				],
			});
		}
	};

	const renderRow = (gabarit: any) => {
		const natureCondition = naturesConditions?.find(
			(n) => n?.codeNature === gabarit?.identifiant,
		);
		return (
			<Table.Row>
				<Table.Cell>{gabarit?.libelle ?? ''}</Table.Cell>
				<Table.Cell>{getLibelleTypeGabarit(gabarit?.types)}</Table.Cell>
				<Table.Cell>
					<Checkbox
						checked={!isNil(natureCondition)}
						onChange={(_e, { checked }) =>
							handleChangeNatureCondition(gabarit, natureCondition, checked)
						}
						data-testid={`natureConditionCheckbox-${gabarit?.libelle}`}
					/>
				</Table.Cell>
			</Table.Row>
		);
	};

	const getAutreNature = () =>
		NATURES_DOCUMENTS.filter(
			(n) =>
				gabaritSubvention.includes(n.gabarit) &&
				!naturesGabarit.some((g) => g.identifiant === n.identifiant),
		).sort((a, b) => a.libelle.localeCompare(b.libelle));

	return (
		<>
			<p>
				Sélectionnez les natures des documents à fournir lors de la demande de
				versement.
				<br />
				Le dossier sera complété avec l&apos;état récapitulatif des dépenses et
				ses factures justificatives
			</p>

			<Table celled striped>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>Type de document</Table.HeaderCell>
						<Table.HeaderCell>Origine</Table.HeaderCell>
						<Table.HeaderCell>A fournir</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Table.Body>
					{naturesGabarit?.map((n: any) => renderRow(n))}
					{getAutreNature()?.map((n: any) => renderRow(n))}
				</Table.Body>
			</Table>
		</>
	);
};

export default EtapeJustificatif;
